<template>
    <div class="p5 mt-5">
        <div class="row">
            <div class="col-sm-6 col-md-3 mx-auto">
                Please wait...
            </div>
        </div>
    </div>
</template>
<script>
    export default  {
        name: 'Home',
        created() {
            window.location.href="/dashboard";
        }
    }
</script>
<style scoped></style>
